import React, { useEffect, useState, useRef } from 'react'
import Wrapper from '../Universal/Wrapper'
import { useParams } from 'react-router-dom';
import { store } from '../../app/store';
import { formatDate, postAPI } from '../../app/api';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { hasPermission, isAdmin } from '../../store/hooks/Permission';

export default function Receipt() {
    const API_URL = process.env.REACT_APP_NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_LIVE;
    const { receipt_id } = useParams();
    const store_data = JSON.parse(store());
    const [organizationDetails, setOrganizationDetails] = useState({});
    const [customerDetails, setCustomerDetails] = useState({});
    const [receiptDetails, setReceiptDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [canView, setCanView] = useState(false);
    const printContent = useRef();
    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                fetchOrganizationDetails();
                fetchReceiptDetails(receipt_id);
            } else {
                const viewAllowed = await hasPermission("EXAM", "Enrollments", "VIEW");
                setCanView(viewAllowed);
                if (viewAllowed) {
                    fetchOrganizationDetails();
                    fetchReceiptDetails(receipt_id);
                }
            }
        };
        checkPermissions();
    }, [store_data?.org_id, receipt_id]);
    const fetchOrganizationDetails = async () => {
        // Fetch organization details logic here
        const response = await postAPI('/organization/fetchSingle', { id: store_data?.org_id });
        if (response?.status) {
            setOrganizationDetails(response?.data?.length > 0 ? response?.data[0] : {});
        }
    }
    const fetchCustomerDetails = async (user_id) => {
        // Fetch customer details logic here
        const response = await postAPI('/customers/fetch-single-student', { user_id: user_id });
        if (response?.status) {
            // console.log("CustomerDetails", response?.data);
            setCustomerDetails(response?.data?.length > 0 ? response?.data[0] : {});
        }
    }
    const fetchReceiptDetails = async (receipt_id) => {
        // Fetch receipt details logic here
        const response = await postAPI('/wallet-recharges/fetch-single', { id: receipt_id });
        if (response?.status) {
            const RechargeData = response?.data || {};
            console.log("RechargeData", RechargeData);
            const txn_response = await postAPI('/student-transactions/fetch-single', { user_unique_id: RechargeData?.user_unique_id, transaction_id: RechargeData?.transaction_id });
            if (txn_response?.status) {
                const TransactionData = txn_response?.data?.length > 0 ? txn_response?.data[0] : {};
                console.log("TransactionData", TransactionData);
                // setCustomerID(RechargeData?.user_id);
                setReceiptDetails({ recharge_data: RechargeData, transaction_data: TransactionData });
                await fetchCustomerDetails(RechargeData?.user_id);
            }
        }
    }
    const printReceiptSection = async () => {
        const element = printContent.current;
        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
            logging: false,
        });
        
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        });
        
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfWidth - imgWidth * ratio) / 2;
        const imgY = 0;
        
        pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
        pdf.autoPrint();
        window.open(pdf.output('bloburl'), '_blank');
    }
    const downloadReceiptSection = async () => {
        const element = printContent.current;
        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
            logging: false,
        });
        
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        });
        
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfWidth - imgWidth * ratio) / 2;
        const imgY = 0;
        
        pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
        pdf.save(`receipt-${receiptDetails?.recharge_data?.transaction_id || 'invoice'}.pdf`);
    }
    return (
        <Wrapper>
            {!canView ? (
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="alert alert-danger">
                        You do not have permission to view this page.
                    </div>
                </div>
            ) : (
                <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-12 col-xl-12 col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Setting/Exams'; }}>
                                Back
                            </button>
                            <p className='text-right mb-0'><small className="fw-bold py-3">Dashboard<span className="text-muted fw-light"> / Exam Invoice</span> </small></p>
                        </div>
                        <div class="row invoice-preview">
                            <div class="col-xl-9 col-md-8 col-12 mb-md-0 mb-6" ref={printContent}>
                                <div class="card invoice-preview-card p-sm-12 p-6">
                                    <div class="card-body">
                                        <div class="d-block svg-illustration gap-2 align-items-center text-center">
                                            <span class="app-brand-logo demo">
                                                <span class="text-primary">
                                                    <img src={`${API_URL}/${organizationDetails?.organization_logo}`} style={{ "width": "200px" }}></img>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="card-body invoice-preview-header rounded">
                                        <div class="d-flex justify-content-between flex-xl-row flex-md-column flex-sm-row flex-column align-items-xl-center align-items-md-start align-items-sm-center align-items-start">
                                            <div class="col-md-7 text-heading">
                                                <p class="mb-2"><b>{organizationDetails?.organization_name || ''}</b></p>
                                                <p class="mb-2">{organizationDetails?.organization_address || ''}</p>
                                                <p class="mb-2">{organizationDetails?.organization_email_id || ''}</p>
                                                <p class="mb-0">{organizationDetails?.organization_contact_number || ''}</p>
                                            </div>
                                            <div className='col-md-5'>
                                                <h6 className='mb-2' style={{marginLeft: '15px'}}>Invoice #{receiptDetails?.recharge_data?.transaction_id}</h6>
                                                <div class="mb-2 text-heading" style={{marginLeft: '15px'}}>
                                                    <span>Date Issues:</span>
                                                    <span class="fw-medium"> {formatDate((receiptDetails?.recharge_data?.transaction_date ? receiptDetails?.recharge_data?.transaction_date : new Date().toISOString()).split('T')[0])?.month} {formatDate((receiptDetails?.recharge_data?.transaction_date ? receiptDetails?.recharge_data?.transaction_date : new Date().toISOString()).split('T')[0])?.day}, {formatDate((receiptDetails?.recharge_data?.transaction_date ? receiptDetails?.recharge_data?.transaction_date : new Date().toISOString()).split('T')[0])?.year}</span>
                                                </div>
                                                <div class="mb-2 text-heading" style={{marginLeft: '15px'}}>
                                                    <span>Payment Date:</span>
                                                    <span class="fw-medium"> {formatDate((receiptDetails?.recharge_data?.transaction_date ? receiptDetails?.recharge_data?.transaction_date : new Date().toISOString()).split('T')[0])?.month} {formatDate((receiptDetails?.recharge_data?.transaction_date ? receiptDetails?.recharge_data?.transaction_date : new Date().toISOString()).split('T')[0])?.day}, {formatDate((receiptDetails?.recharge_data?.transaction_date ? receiptDetails?.recharge_data?.transaction_date : new Date().toISOString()).split('T')[0])?.year}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body p-6">
                                        <div class="row">
                                            <div class="col-xl-7 col-md-12 col-sm-7 col-12">
                                                <h6>Invoice To:</h6>
                                                <p class="mb-2"><b>{customerDetails?.first_name} {customerDetails?.last_name}</b></p>
                                                <p class="mb-2">{customerDetails?.address_line_1} {customerDetails?.address_line_2} {customerDetails?.city} {customerDetails?.state_name} {customerDetails?.country} {customerDetails?.pincode}</p>
                                                <p class="mb-2">{customerDetails?.email_id}</p>
                                                <p class="mb-0">{customerDetails?.contact_number}</p>
                                                {/* <p class="mb-1">718-986-6062</p> */}
                                                {/* <p class="mb-0">peakyFBlinders@gmail.com</p> */}
                                            </div>
                                            <div class="col-xl-5 col-md-12 col-sm-5 col-12">
                                                <h6>Billing Summary:</h6>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td class="pe-4">Payment Date:</td>
                                                            <td>{formatDate((receiptDetails?.recharge_data?.transaction_date ? receiptDetails?.recharge_data?.transaction_date : new Date().toISOString()).split('T')[0])?.month} {formatDate((receiptDetails?.recharge_data?.transaction_date ? receiptDetails?.recharge_data?.transaction_date : new Date().toISOString()).split('T')[0])?.day}, {formatDate((receiptDetails?.recharge_data?.transaction_date ? receiptDetails?.recharge_data?.transaction_date : new Date().toISOString()).split('T')[0])?.year}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="pe-4">Gateway:</td>
                                                            <td>{receiptDetails?.transaction_data?.gateway}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="pe-4">Payment Amount:</td>
                                                            <td class="fw-medium">{receiptDetails?.transaction_data?.txn_amount}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="pe-4">Mode of Payment:</td>
                                                            <td>{receiptDetails?.transaction_data?.payment_mode}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="pe-4">Status:</td>
                                                            <td>{receiptDetails?.transaction_data?.transaction_status}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div class="card-body table-responsive border border-bottom-0 border-top-0 p-6 rounded">
                                        <table class="table m-0">
                                            <thead>
                                                <tr>
                                                    <th>Item</th>
                                                    <th>Description</th>
                                                    <th>Cost</th>
                                                    <th>Qty</th>
                                                    <th>Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="text-nowrap text-heading">Vuexy Admin Template</td>
                                                    <td class="text-nowrap">HTML Admin Template</td>
                                                    <td>$32</td>
                                                    <td>1</td>
                                                    <td>$32.00</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-nowrap text-heading">Frest Admin Template</td>
                                                    <td class="text-nowrap">Angular Admin Template</td>
                                                    <td>$22</td>
                                                    <td>1</td>
                                                    <td>$22.00</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-nowrap text-heading">Apex Admin Template</td>
                                                    <td class="text-nowrap">HTML Admin Template</td>
                                                    <td>$17</td>
                                                    <td>2</td>
                                                    <td>$34.00</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-nowrap text-heading">Robust Admin Template</td>
                                                    <td class="text-nowrap">React Admin Template</td>
                                                    <td>$66</td>
                                                    <td>1</td>
                                                    <td>$66.00</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> */}
                                    <div class="card-body table-responsive p-6">
                                        <table class="table m-0 table-borderless">
                                            <tbody>
                                                <tr>
                                                    <td class="align-top pe-6 ps-0 py-6 text-body">
                                                        {/* <p class="mb-1">
                                                            <span class="me-2 h6">Salesperson:</span>
                                                            <span>Alfie Solomons</span>
                                                        </p> */}
                                                        <span>Thanks for your business</span>
                                                    </td>
                                                    <td class="align-top pe-6 ps-0 py-6 text-body">
                                                        <h3 className='text-right text-uppercase fg-green'>{receiptDetails?.recharge_data?.status}</h3>
                                                    </td>
                                                    {/* <td class="px-0 py-6 w-px-100">
                                                        <p class="mb-2">Subtotal:</p>
                                                        <p class="mb-2">Discount:</p>
                                                        <p class="mb-2 border-bottom pb-2">Tax:</p>
                                                        <p class="mb-0">Total:</p>
                                                    </td>
                                                    <td class="text-end px-0 py-6 w-px-100 fw-medium text-heading">
                                                        <p class="fw-medium mb-2">$1800</p>
                                                        <p class="fw-medium mb-2">$28</p>
                                                        <p class="fw-medium mb-2 border-bottom pb-2">21%</p>
                                                        <p class="fw-medium mb-0">$1690</p>
                                                    </td> */}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <hr class="mt-0 mb-6" />
                                    {/* <div class="card-body p-6">
                                        <div class="row">
                                            <div class="col-12">
                                                <span class="fw-medium text-heading">Note:</span>
                                                <span>It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!</span>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-4 col-12 invoice-actions">
                                <div class="card">
                                    <div class="card-body">
                                        <button type='button' onClick={downloadReceiptSection} class="btn btn-primary d-grid w-100 mb-4 waves-effect waves-light" data-bs-toggle="offcanvas" data-bs-target="#sendInvoiceOffcanvas">
                                            <span class="d-flex align-items-center justify-content-center text-nowrap"><i class="icon-base ti tabler-send icon-xs me-2"></i>Download</span>
                                        </button>
                                        {/* <button class="btn btn-label-secondary d-grid w-100 mb-4 waves-effect">Download</button>
                                        <div class="d-flex mb-4">
                                            <a class="btn btn-label-secondary d-grid w-100 me-4 waves-effect" target="_blank" href="./app-invoice-print.html"> Print </a>
                                            <a href="./app-invoice-edit.html" class="btn btn-label-secondary d-grid w-100 waves-effect"> Edit </a>
                                        </div> */}
                                        <button type='button' onClick={printReceiptSection} class="btn btn-success d-grid w-100 waves-effect waves-light" data-bs-toggle="offcanvas" data-bs-target="#addPaymentOffcanvas">
                                            <span class="d-flex align-items-center justify-content-center text-nowrap"><i class="icon-base ti tabler-currency-dollar icon-xs me-2"></i>Print</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            )}
        </Wrapper>
    )
}
